import React from 'react';

import { useParams } from 'react-router-dom';

async function exportResults(projectName) {
  const results = [];
  let nextPage = null;

  do {
    let url = `https://firestore.googleapis.com/v1/projects/enigmeta-parcitypate/databases/(default)/documents/results/`;
    if (nextPage) { url += `?pageToken=${nextPage}` }
    const res = await fetch(url);
    const json = await res.json();
    nextPage = json.nextPageToken

    for (const doc of json.documents) {
      let result = {};
      if (!doc.fields.sid || !doc.fields.sid.stringValue.length) continue;
      if (doc.fields.project.stringValue !== projectName) continue;

      result.sid = doc.fields.sid.stringValue;

      for (const key in doc.fields) {
        if (key === 'sid') {
          continue;
        } else if (key === 'project') {
          continue;
        } else {
          result[key] = parseInt(doc.fields[key].integerValue);
        }
      }
      results.push(result);
    }
  } while (nextPage)
  return results;
}

function downloadFile(fileName, text) {
  const element = document.createElement('a');
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
  element.setAttribute('download', fileName);
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
}

export default function Dashboard() {
  let { project } = useParams();

  const handleExport = async () => {
    const results = await exportResults(project);
    if (results.length === 0) {
      alert('No results found.');
      return;
    }
    const headers = Object.keys(results[0]);
    let csv = headers.join(';') + '\n';
    for (const row of results) {
      csv += headers.map((key) => row[key]).join(';') + '\n';
    }
    downloadFile(`${project}-results.csv`, csv);
  };

  return (
    <div className="home dashboard">
      <div className="home__sidebar">
        <h1>{project}</h1>
        <div className="home__tab home__tab--active">
          <span className="home__tab-text">Export</span>
        </div>
      </div>
      <div className="home__main">
        <div className="home__header">Dashboard</div>
        <div className="home__content">
          <h2>Export Results</h2>
          <p>Save the results to a .csv file, ready to open in Excel.</p>
          <p>
            <button onClick={handleExport}>Export Results</button>
          </p>
        </div>
      </div>
    </div>
  );
}
